module.exports = __webpack_public_path__ + "static/image/history/pc/201501@3x.ver2_0_2.jpg?4305ff72";